import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";

import rootReducer from "reducers/rootReducer";

export default preloadedState =>
    createStore(rootReducer, preloadedState, applyMiddleware(thunkMiddleware));



// WEBPACK FOOTER //
// ./src/store/store.js